
import React, { useEffect, useState } from "react";
import { Box, Skeleton, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import FeaturesHeroCard from "../../components/cards/FeaturesHeroCard";
import acc2_eng from "../../assets/acc2_eng.png"; // Adjust the path as necessary
import acc2_spa from "../../assets/acc2_spa.png"; // Adjust the path
import i18next from "i18next";
import {BASE_URL} from "../../components/BASE_URL"
const CompanyListSection = () => {
    const { t ,i18n} = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));


     const [loadingCompanyList, setLoadingCompanyList] = useState(true);
  const [companyListData, setCompanyListData] = useState(null);

  const parseFeatureNames = (list) => {
    try {
      const items = Array.isArray(list)
        ? list
        : list
          ? JSON.parse(list)
          : [];
      return items.map((f) => f.name);
    } catch {
      return [];
    }
  };

useEffect(() => {
  const fetchCompanyList = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Company_List`
      );
      const data = await response.json();
      if (!data.error && data.data.length > 0) {
        const section = data.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        if (item) {
          setCompanyListData({
            title: item.title,
            description: item.description,
            features: parseFeatureNames(item.list),
          });
        }
      }
    } catch (error) {
      console.error("Error fetching Company List:", error);
    } finally {
      setLoadingCompanyList(false);
    }
  };

  fetchCompanyList();
}, [i18n.language]);


    return (
       
           <Box id="company-list-section">
      {loadingCompanyList ? (
        <Box sx={{ p: 3 }}>
          <Skeleton variant="text" width={280} height={50} />
          <Skeleton variant="text" width={500} height={30} />
          <Skeleton variant="rectangular" width="100%" height={180} sx={{ mt: 2 }} />
        </Box>
      ) : (
        <FeaturesHeroCard
          bgColor="#FFFFFF"
          image={i18next.language === "es" ? acc2_spa : acc2_eng}
          imagePosition="right"
          title={companyListData?.title}
          description={companyListData?.description}
          features={companyListData?.features}
        />
      )}
    </Box>
    );
};

export default CompanyListSection;




